<template>
  <section>
    <h4>City</h4>
    <span>*Input English first, we might have a translations ready</span>

    <md-autocomplete
      v-model="value.en"
      :md-options="localizationAutocompleteOptions"
      @md-selected="matchSelectedOption"
    >
      <label>English</label>
    </md-autocomplete>

    <md-field
      v-for="locale in secondaryLocales"
      :key="locale"
    >
      <label>{{ localeCodeToLabel[locale] }}</label>
      <md-input v-model="value[locale]" />
    </md-field>

    <div
      v-if="error"
      class="error-feedback"
    >
      City is required
    </div>
  </section>
</template>

<script>
  import { LOCALES_LIST, localeCodeToLabel } from "@/utils/currentLocalesList";

  export default {
    props: {
      value: { type: Object, required: true },
      error: { type: String, required: false, default: "" }
    },
    data() {
      return {
        localizationDictionaries: [],
        localizationAutocompleteOptions: [],

        secondaryLocales: LOCALES_LIST.slice(1),
        localeCodeToLabel
      };
    },
    mounted() {
      this.$http.get("/v1/admin/node/localizations").then((res) => {
        this.localizationDictionaries = res.data.localization.map(localization => localization.city);
        this.localizationAutocompleteOptions = res.data.localization.map(localization => localization.city.en);
      });
    },
    methods: {
      matchSelectedOption(selected) {
        console.log(selected);
        const match = this.localizationDictionaries.find(local => local.en === selected);
        if (match) {
          this.$emit("input", match);
          this.value = match;
        }
      }
    }
  };
</script>
